import { render, staticRenderFns } from "./SVGEditProjectName.vue?vue&type=template&id=539ca5f3&scoped=true&"
import script from "./SVGEditProjectName.vue?vue&type=script&lang=js&"
export * from "./SVGEditProjectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ca5f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539ca5f3')) {
      api.createRecord('539ca5f3', component.options)
    } else {
      api.reload('539ca5f3', component.options)
    }
    module.hot.accept("./SVGEditProjectName.vue?vue&type=template&id=539ca5f3&scoped=true&", function () {
      api.rerender('539ca5f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGEditProjectName.vue"
export default component.exports